// extracted by mini-css-extract-plugin
export default {"contentDiv":"JournalContentModal_contentDiv__v8bjL"};